// src/utils/oauth.tsx
var standardProviders = ["google", "github", "microsoft", "spotify", "facebook", "discord", "gitlab", "bitbucket", "linkedin", "apple", "x", "twitch"];
var sharedProviders = ["google", "github", "microsoft", "spotify"];
var allProviders = standardProviders;
var publishableClientKeyNotNecessarySentinel = "__stack_public_client__";
export {
  allProviders,
  publishableClientKeyNotNecessarySentinel,
  sharedProviders,
  standardProviders
};
//# sourceMappingURL=oauth.js.map